// extracted by mini-css-extract-plugin
export default {"container":"StringIdHeaderComponent-module__container__1_Ucx"};